export default __webpack_public_path__ + "static/content4-061fa041d85482bf7a24d059c7ba1540.jpeg";